export const translations = {
  es: {
    // Auth
    auth_title: "ARIA Wallet",
    auth_subtitle: "by AriaPC · Tu gestor financiero personal",
    auth_login: "Iniciar sesión",
    auth_register: "Crear cuenta",
    auth_email: "Email",
    auth_password: "Contraseña",
    auth_password_repeat: "Repetir contraseña",
    auth_name: "Tu nombre",
    auth_name_placeholder: "Juan García",
    auth_login_btn: "Iniciar sesión →",
    auth_register_btn: "Crear cuenta gratis →",
    auth_logging_in: "Entrando...",
    auth_registering: "Creando cuenta...",
    auth_forgot: "¿Olvidaste tu contraseña?",
    auth_reset_title: "Escribe tu email y te enviaremos un enlace para restablecer tu contraseña.",
    auth_reset_btn: "Enviar enlace",
    auth_reset_back: "← Volver al login",
    auth_reset_sent: "Te hemos enviado un email para restablecer tu contraseña.",
    auth_err_profile: "Selecciona un perfil.",
    auth_err_name: "Escribe tu nombre.",
    auth_err_pass_match: "Las contraseñas no coinciden.",
    auth_err_pass_length: "La contraseña debe tener al menos 6 caracteres.",
    auth_err_email_used: "Este email ya está registrado.",
    auth_err_generic: "Error al crear la cuenta. Inténtalo de nuevo.",
    auth_err_login: "Email o contraseña incorrectos.",
    auth_err_email: "No encontramos esa cuenta.",
    auth_err_no_email: "Escribe tu email.",
    auth_profile_label: "¿Para qué vas a usarlo?",
    auth_profile_personal: "Personal",
    auth_profile_personal_desc: "Hogar, gastos y ahorro familiar",
    auth_profile_business: "Negocio",
    auth_profile_business_desc: "Ventas, compras e inversión",
    auth_trial_note: "Plan gratuito limitado · O activa Pro por 1,99€/mes",
    auth_lang: "Idioma",
    auth_min_chars: "Mín. 6 caracteres",

    // Layout nav
    nav_panel: "Panel",
    nav_charts: "Gráficos",
    nav_accounts: "Cuentas",
    nav_add: "Añadir entrada",
    nav_history: "Historial",
    nav_settings: "Ajustes",
    nav_logout: "Cerrar sesión",
    nav_pro: "Plan Pro",
    nav_trial: "Prueba gratuita",
    nav_free: "Plan Gratuito",
    nav_trial_days: "días restantes",
    nav_full_access: "Acceso completo",
    nav_free_limit: "30 entradas/mes · 3 meses",
    nav_trial_warning: "Tu prueba acaba pronto",
    nav_trial_warning_sub: "Hazte Pro para no perder acceso",
    nav_activate_pro: "Pro — 1,99€/mes",
    nav_go_pro: "Hazte Pro — 1,99€/mes",
    nav_trial_banner: "Prueba gratuita —",
    nav_trial_banner_days: "días restantes con acceso completo",
    nav_activate_pro_btn: "Activar Pro 1,99€/mes →",
    app_name: "ARIA Wallet",

    // Panel
    panel_title: "Panel",
    panel_sub: "Resumen de tus",
    panel_add: "Añadir entrada",
    panel_pro_banner_title: "Hazte Pro por solo 1,99€/mes",
    panel_pro_banner_sub: "Entradas ilimitadas · Todo el historial · 4 gráficos · Exportar CSV",
    panel_pro_btn: "Ver plan Pro →",
    panel_entries_month: "Entradas este mes:",
    panel_expand: "Ampliar →",
    panel_all_years: "Todos los años",
    panel_all_months: "Todos",
    panel_accounts_title: "Cuentas",
    panel_no_data: "Sin datos todavía",
    panel_no_data_sub: "Añade tu primera entrada para ver el resumen aquí",
    panel_year: "Año",
    panel_month: "Mes",

    // Añadir
    add_title: "Añadir entrada",
    add_sub: "Registra un",
    add_sub2: "o",
    add_type: "Tipo de movimiento",
    add_cat: "Categoría",
    add_cat_placeholder: "Selecciona una categoría",
    add_desc: "Descripción",
    add_desc_optional: "(opcional)",
    add_desc_placeholder: "Ej: Nómina enero, Hipoteca, MacBook Pro...",
    add_account: "Cuenta / Método de pago",
    add_no_account: "Sin asignar",
    add_amount: "Importe (€)",
    add_datetime: "Fecha y hora",
    add_datetime_placeholder: "DD/MM/AAAA HH:MM",
    add_datetime_format: "Formato: DD/MM/AAAA HH:MM",
    add_now: "Ahora",
    add_btn: "Añadir entrada",
    add_saving: "Guardando...",
    add_success: "Entrada guardada correctamente",
    add_err_amount: "Introduce un importe válido.",
    add_err_date: "Fecha inválida. Usa DD/MM/AAAA HH:MM",
    add_other: "Otro",
    add_entries_month: "Entradas este mes:",
    add_expand: "Ampliar →",

    // Historial
    hist_title: "Historial",
    hist_results: "resultado(s)",
    hist_free_plan: "Plan gratuito: mostrando últimos 3 meses.",
    hist_see_all: "Ver todo con Pro →",
    hist_all_years: "Todos los años",
    hist_all_months: "Todos los meses",
    hist_all_types: "Todos",
    hist_search: "Buscar...",
    hist_min: "Mín €",
    hist_max: "Máx €",
    hist_no_results: "Sin resultados",
    hist_date: "Fecha y hora",
    hist_type: "Tipo",
    hist_account: "Cuenta",
    hist_cat: "Categoría",
    hist_desc: "Descripción",
    hist_amount: "Importe €",
    hist_export: "Exportar CSV",
    hist_delete_confirm: "¿Eliminar esta entrada?",

    // Cuentas
    acc_title: "Cuentas y monederos",
    acc_no_accounts: "Sin cuentas todavía.",
    acc_new: "Nueva cuenta",
    acc_name: "Nombre",
    acc_name_placeholder: "Ej: CaixaBank, Wise...",
    acc_initial: "Saldo inicial (€)",
    acc_color: "Color",
    acc_add_btn: "Añadir cuenta",
    acc_select: "",
    acc_select_title: "Selecciona una cuenta",
    acc_select_sub: "Haz clic en una cuenta para ver sus movimientos",
    acc_initial_bal: "Saldo inicial",
    acc_total_in: "Total entradas",
    acc_total_out: "Total salidas",
    acc_current: "Saldo actual",
    acc_no_movements: "Sin movimientos registrados en esta cuenta",
    acc_date: "Fecha",
    acc_type: "Tipo",
    acc_cat: "Categoría",
    acc_desc: "Descripción",
    acc_amount: "Importe €",
    acc_balance: "Saldo €",
    acc_err_name: "Escribe un nombre",
    acc_err_exists: "Ya existe esa cuenta",
    acc_delete_confirm: "¿Eliminar la cuenta",

    // Ajustes
    settings_title: "Ajustes",
    settings_saved: "Cambios guardados",
    settings_labels: "Personalizar etiquetas",
    settings_income_label: "Nombre de ingresos",
    settings_expense_label: "Nombre de gastos",
    settings_balance_label: "Nombre del balance",
    settings_fund_label: "Nombre del fondo",
    settings_fund_pct: "% destinado al fondo",
    settings_cats: "Categorías",
    settings_income_cats: "Categorías de",
    settings_expense_cats: "Categorías de",
    settings_cats_hint: "(una por línea)",
    settings_save: "Guardar cambios",
    settings_logout: "Cerrar sesión",
    settings_logout_confirm: "¿Cerrar sesión?",
    settings_lang: "Idioma de la aplicación",

    // Gráficos
    charts_title: "Gráficos",
    charts_sub: "Visualiza la evolución de tus finanzas",
    charts_all_years: "Todos los años",
    charts_pro_title: "Gráficos completos en Plan Pro",
    charts_pro_sub: "Con el plan gratuito ves el gráfico de barras. Hazte Pro para ver todos los gráficos.",
    charts_pro_btn: "Ver plan Pro →",
    charts_no_data: "Sin datos todavía",
    charts_no_data_sub: "Añade entradas para ver los gráficos",
    charts_bar_title: "vs",
    charts_bar_title2: "por mes",
    charts_line_title: "Evolución del",
    charts_locked: "Solo en Plan Pro",
    charts_unlock: "Desbloquear →",
    charts_exp_pie: "por categoría",
    charts_inc_pie: "por categoría",
    charts_no_data_pie: "Sin datos",

    // Pro page
    pro_title: "ARIA Wallet Pro",
    pro_sub: "Todo lo que necesitas para controlar tus finanzas",
    pro_price: "1,99€",
    pro_month: "/mes",
    pro_cancel: "Cancela cuando quieras",
    pro_active: "Ya tienes el Plan Pro activo. ¡Gracias!",
    pro_trial_info: "Estás en tu prueba gratuita ·",
    pro_trial_days: "días restantes con acceso completo",
    pro_trial_btn: "Activar Pro ahora — 1,99€/mes →",
    pro_expired: "Tu prueba gratuita ha terminado. Activa Pro para recuperar el acceso completo.",
    pro_btn: "Activar Pro — 1,99€/mes →",
    pro_note1: "No perderás acceso · Pago seguro · Cancela cuando quieras",
    pro_note2: "Pago seguro · Sin permanencia · Cancela cuando quieras",
    pro_err: "Error al conectar con el servidor de pagos.",
    pro_features: [
      ["","Entradas ilimitadas","Sin límite de registros al mes"],
      ["","Historial completo","Accede a todos tus datos históricos"],
      ["","4 gráficos avanzados","Barras, línea de beneficio y 2 tartas por categoría"],
      ["","Cuentas ilimitadas","Gestiona todas tus cuentas y tarjetas"],
      ["","Exportar CSV","Descarga todos tus datos en Excel"],
      ["","Personalización total","Etiquetas, categorías y porcentajes a medida"],
      ["","Soporte por email","Respuesta en menos de 24h"],
    ],

    // Success
    success_title: "¡Bienvenido a Pro!",
    success_sub: "Tu suscripción está activa. Ya tienes acceso completo a todas las funciones.",
    success_btn: "Ir al panel →",

    // Default config
    income_label: "Ingresos",
    expense_label: "Gastos",
    balance_label: "Balance",
    fund_label: "Ahorro",
    income_cats_personal: ["Salario","Ventas","Regalos","Ayudas","Inversiones","Otros"],
    expense_cats_personal: ["Vivienda","Alimentación","Transporte","Salud","Ocio","Compras","Suscripciones","Educación","Mascotas","Ahorro","Otros"],
    income_label_biz: "Ventas",
    expense_label_biz: "Compras",
    balance_label_biz: "Beneficio",
    fund_label_biz: "Inversión",
    income_cats_biz: ["Ventas","Servicios","Comisiones","Inversiones","Otros"],
    expense_cats_biz: ["Material","Publicidad","Software","Transporte","Alquiler","Nóminas","Impuestos","Servicios","Equipamiento","Otros"],

    // Landing page
    landing_app_name: "ARIA Wallet",
    landing_login: "Iniciar sesión",
    landing_register: "Registrarse",
    landing_badge: "PLAN GRATUITO DISPONIBLE",
    landing_hero_title_1: "¿A dónde va tu dinero",
    landing_hero_title_2: "cada mes?",
    landing_hero_sub: "Registra tus ingresos y gastos en segundos, visualiza tus finanzas en tiempo real y toma el control de tu dinero.",
    landing_hero_sub_strong: "Simple, rápido y seguro.",
    landing_cta_register: "Crear cuenta gratis →",
    landing_cta_pricing: "Ver precios",
    landing_mockup_balance_label: "SALDO ESTE MES",
    landing_mockup_income: "Ingresos",
    landing_mockup_expense: "Gastos",
    landing_mockup_row1: "Salario · Nómina",
    landing_mockup_row2: "Vivienda · Alquiler",
    landing_mockup_row3: "Transporte · Gasolina",
    landing_benefits_title_1: "Todo lo que necesitas para",
    landing_benefits_title_2: "controlar tus finanzas",
    landing_benefit_1_title: "Registra en segundos",
    landing_benefit_1_desc: "Añade ingresos y gastos fácilmente con categorías personalizables. Sin complicaciones.",
    landing_benefit_2_title: "Visualiza tu situación",
    landing_benefit_2_desc: "Gráficos claros de ingresos vs gastos, evolución del balance y distribución por categoría.",
    landing_benefit_3_title: "Presupuestos por categoría",
    landing_benefit_3_desc: "Define un límite mensual por categoría y recibe alertas cuando te acercas al límite. Controla tus gastos sin esfuerzo.",
    landing_benefit_4_title: "Gestiona pendientes",
    landing_benefit_4_desc: "Controla cobros y pagos pendientes para que nunca se te pase una fecha importante.",
    landing_benefit_5_title: "Pagos recurrentes",
    landing_benefit_5_desc: "Registra tus gastos fijos mensuales una sola vez y olvídate de apuntarlos cada mes.",
    landing_benefit_6_title: "Múltiples cuentas",
    landing_benefit_6_desc: "Organiza tu dinero por cuentas bancarias, efectivo o monederos digitales.",
    landing_benefit_7_title: "Varias monedas",
    landing_benefit_7_desc: "Trabaja en euros, dólares latinoamericanos, libras y muchas otras monedas según tus necesidades.",
    landing_benefit_8_title: "Exporta tus datos",
    landing_benefit_8_desc: "Descarga tu historial en CSV para analizarlo o guardarlo cuando quieras.",
    landing_pricing_title: "Precios simples y transparentes",
    landing_pricing_sub: "Sin sorpresas. Cancela cuando quieras.",
    landing_plan_free: "GRATUITO",
    landing_plan_free_period: "Para siempre",
    landing_plan_free_f1: "30 entradas al mes",
    landing_plan_free_f2: "3 meses de historial",
    landing_plan_free_f3: "Gráficos básicos",
    landing_plan_free_f4: "Todas las categorías",
    landing_plan_free_cta: "Empezar gratis",
    landing_plan_pro: "PRO",
    landing_plan_popular: "MÁS POPULAR",
    landing_billing_monthly: "Mensual",
    landing_billing_annual: "Anual",
    landing_price_monthly_period: "/mes",
    landing_price_monthly_note: "Facturado mensualmente",
    landing_price_annual_period: "/año",
    landing_price_annual_note_1: "Equivale a 1,67€/mes ·",
    landing_price_annual_note_2: "Ahorra 4€",
    landing_plan_pro_f1: "Entradas ilimitadas",
    landing_plan_pro_f2: "Historial completo",
    landing_plan_pro_f3: "Gráficos avanzados",
    landing_plan_pro_f4: "Presupuestos por categoría",
    landing_plan_pro_f5: "Exportar CSV",
    landing_plan_pro_f6: "Múltiples monedas",
    landing_plan_pro_f7: "Soporte prioritario",
    landing_plan_pro_cta: "Suscribirse ahora →",
    landing_final_title: "Empieza a controlar tu dinero hoy",
    landing_final_sub: "Únete a los usuarios que ya saben a dónde va su dinero cada mes.",
    landing_footer_privacy: "Privacidad",
    landing_footer_terms: "Términos",
  },

  en: {
    // Auth
    auth_title: "ARIA Wallet",
    auth_subtitle: "by AriaPC · Your personal finance manager",
    auth_login: "Sign in",
    auth_register: "Create account",
    auth_email: "Email",
    auth_password: "Password",
    auth_password_repeat: "Repeat password",
    auth_name: "Your name",
    auth_name_placeholder: "John Smith",
    auth_login_btn: "Sign in →",
    auth_register_btn: "Create free account →",
    auth_logging_in: "Signing in...",
    auth_registering: "Creating account...",
    auth_forgot: "Forgot your password?",
    auth_reset_title: "Enter your email and we'll send you a link to reset your password.",
    auth_reset_btn: "Send link",
    auth_reset_back: "← Back to login",
    auth_reset_sent: "We've sent you an email to reset your password.",
    auth_err_profile: "Select a profile.",
    auth_err_name: "Enter your name.",
    auth_err_pass_match: "Passwords don't match.",
    auth_err_pass_length: "Password must be at least 6 characters.",
    auth_err_email_used: "This email is already registered.",
    auth_err_generic: "Error creating account. Please try again.",
    auth_err_login: "Incorrect email or password.",
    auth_err_email: "We couldn't find that account.",
    auth_err_no_email: "Enter your email.",
    auth_profile_label: "What will you use it for?",
    auth_profile_personal: "Personal",
    auth_profile_personal_desc: "Home, expenses and family savings",
    auth_profile_business: "Business",
    auth_profile_business_desc: "Sales, purchases and investment",
    auth_trial_note: "Limited free plan · Or activate Pro for €1.99/month",
    auth_lang: "Language",
    auth_min_chars: "Min. 6 characters",

    // Layout nav
    nav_panel: "Dashboard",
    nav_charts: "Charts",
    nav_accounts: "Accounts",
    nav_add: "Add entry",
    nav_history: "History",
    nav_settings: "Settings",
    nav_logout: "Sign out",
    nav_pro: "Pro Plan",
    nav_trial: "Free trial",
    nav_free: "Free Plan",
    nav_trial_days: "days left",
    nav_full_access: "Full access",
    nav_free_limit: "30 entries/month · 3 months",
    nav_trial_warning: "Your trial ends soon",
    nav_trial_warning_sub: "Go Pro to keep access",
    nav_activate_pro: "Pro — €1.99/month",
    nav_go_pro: "Go Pro — €1.99/month",
    nav_trial_banner: "Free trial —",
    nav_trial_banner_days: "days left with full access",
    nav_activate_pro_btn: "Activate Pro €1.99/month →",
    app_name: "ARIA Wallet",

    // Panel
    panel_title: "Dashboard",
    panel_sub: "Summary of your",
    panel_add: "Add entry",
    panel_pro_banner_title: "Go Pro for just €1.99/month",
    panel_pro_banner_sub: "Unlimited entries · Full history · 4 charts · Export CSV",
    panel_pro_btn: "See Pro plan →",
    panel_entries_month: "Entries this month:",
    panel_expand: "Upgrade →",
    panel_all_years: "All years",
    panel_all_months: "All",
    panel_accounts_title: "Accounts",
    panel_no_data: "No data yet",
    panel_no_data_sub: "Add your first entry to see the summary here",
    panel_year: "Year",
    panel_month: "Month",

    // Añadir
    add_title: "Add entry",
    add_sub: "Record a",
    add_sub2: "or",
    add_type: "Transaction type",
    add_cat: "Category",
    add_cat_placeholder: "Select a category",
    add_desc: "Description",
    add_desc_optional: "(optional)",
    add_desc_placeholder: "E.g: January salary, Mortgage, MacBook Pro...",
    add_account: "Account / Payment method",
    add_no_account: "Unassigned",
    add_amount: "Amount (€)",
    add_datetime: "Date and time",
    add_datetime_placeholder: "DD/MM/YYYY HH:MM",
    add_datetime_format: "Format: DD/MM/YYYY HH:MM",
    add_now: "Now",
    add_btn: "Add entry",
    add_saving: "Saving...",
    add_success: "Entry saved successfully",
    add_err_amount: "Enter a valid amount.",
    add_err_date: "Invalid date. Use DD/MM/YYYY HH:MM",
    add_other: "Other",
    add_entries_month: "Entries this month:",
    add_expand: "Upgrade →",

    // Historial
    hist_title: "History",
    hist_results: "result(s)",
    hist_free_plan: "Free plan: showing last 3 months.",
    hist_see_all: "See all with Pro →",
    hist_all_years: "All years",
    hist_all_months: "All months",
    hist_all_types: "All",
    hist_search: "Search...",
    hist_min: "Min €",
    hist_max: "Max €",
    hist_no_results: "No results",
    hist_date: "Date and time",
    hist_type: "Type",
    hist_account: "Account",
    hist_cat: "Category",
    hist_desc: "Description",
    hist_amount: "Amount €",
    hist_export: "Export CSV",
    hist_delete_confirm: "Delete this entry?",

    // Cuentas
    acc_title: "Accounts & wallets",
    acc_no_accounts: "No accounts yet.",
    acc_new: "New account",
    acc_name: "Name",
    acc_name_placeholder: "E.g: Chase, Wise...",
    acc_initial: "Initial balance (€)",
    acc_color: "Color",
    acc_add_btn: "Add account",
    acc_select: "",
    acc_select_title: "Select an account",
    acc_select_sub: "Click on an account to see its movements",
    acc_initial_bal: "Initial balance",
    acc_total_in: "Total income",
    acc_total_out: "Total expenses",
    acc_current: "Current balance",
    acc_no_movements: "No movements recorded in this account",
    acc_date: "Date",
    acc_type: "Type",
    acc_cat: "Category",
    acc_desc: "Description",
    acc_amount: "Amount €",
    acc_balance: "Balance €",
    acc_err_name: "Enter a name",
    acc_err_exists: "That account already exists",
    acc_delete_confirm: "Delete account",

    // Ajustes
    settings_title: "Settings",
    settings_saved: "Changes saved",
    settings_labels: "Customize labels",
    settings_income_label: "Income name",
    settings_expense_label: "Expense name",
    settings_balance_label: "Balance name",
    settings_fund_label: "Fund name",
    settings_fund_pct: "% allocated to fund",
    settings_cats: "Categories",
    settings_income_cats: "Categories for",
    settings_expense_cats: "Categories for",
    settings_cats_hint: "(one per line)",
    settings_save: "Save changes",
    settings_logout: "Sign out",
    settings_logout_confirm: "Sign out?",
    settings_lang: "App language",

    // Gráficos
    charts_title: "Charts",
    charts_sub: "Visualize the evolution of your finances",
    charts_all_years: "All years",
    charts_pro_title: "Full charts in Pro Plan",
    charts_pro_sub: "Free plan shows bar chart only. Go Pro to see all charts.",
    charts_pro_btn: "See Pro plan →",
    charts_no_data: "No data yet",
    charts_no_data_sub: "Add entries to see charts",
    charts_bar_title: "vs",
    charts_bar_title2: "by month",
    charts_line_title: "Evolution of",
    charts_locked: "Pro Plan only",
    charts_unlock: "Unlock →",
    charts_exp_pie: "by category",
    charts_inc_pie: "by category",
    charts_no_data_pie: "No data",

    // Pro page
    pro_title: "ARIA Wallet Pro",
    pro_sub: "Everything you need to control your finances",
    pro_price: "€1.99",
    pro_month: "/month",
    pro_cancel: "Cancel anytime",
    pro_active: "You already have the Pro Plan active. Thank you!",
    pro_trial_info: "You're on your free trial ·",
    pro_trial_days: "days left with full access",
    pro_trial_btn: "Activate Pro now — €1.99/month →",
    pro_expired: "Your free trial has ended. Activate Pro to regain full access.",
    pro_btn: "Activate Pro — €1.99/month →",
    pro_note1: "No loss of access · Secure payment · Cancel anytime",
    pro_note2: "Secure payment · No commitment · Cancel anytime",
    pro_err: "Error connecting to payment server.",
    pro_features: [
      ["","Unlimited entries","No monthly record limit"],
      ["","Full history","Access all your historical data"],
      ["","4 advanced charts","Bars, profit line and 2 category pies"],
      ["","Unlimited accounts","Manage all your accounts and cards"],
      ["","Export CSV","Download all your data to Excel"],
      ["","Full customization","Custom labels, categories and percentages"],
      ["","Email support","Response in less than 24h"],
    ],

    // Success
    success_title: "Welcome to Pro!",
    success_sub: "Your subscription is active. You now have full access to all features.",
    success_btn: "Go to dashboard →",

    // Default config
    income_label: "Income",
    expense_label: "Expenses",
    balance_label: "Balance",
    fund_label: "Savings",
    income_cats_personal: ["Salary","Sales","Gifts","Benefits","Investments","Other"],
    expense_cats_personal: ["Housing","Food","Transport","Health","Leisure","Shopping","Subscriptions","Education","Pets","Savings","Other"],
    income_label_biz: "Revenue",
    expense_label_biz: "Purchases",
    balance_label_biz: "Profit",
    fund_label_biz: "Investment",
    income_cats_biz: ["Sales","Services","Commissions","Investments","Other"],
    expense_cats_biz: ["Materials","Advertising","Software","Transport","Rent","Payroll","Taxes","Services","Equipment","Other"],

    // Landing page
    landing_app_name: "ARIA Wallet",
    landing_login: "Sign in",
    landing_register: "Sign up",
    landing_badge: "FREE PLAN AVAILABLE",
    landing_hero_title_1: "Where does your money",
    landing_hero_title_2: "go every month?",
    landing_hero_sub: "Track your income and expenses in seconds, see your finances in real time, and take control of your money.",
    landing_hero_sub_strong: "Simple, fast, and secure.",
    landing_cta_register: "Create free account →",
    landing_cta_pricing: "See pricing",
    landing_mockup_balance_label: "BALANCE THIS MONTH",
    landing_mockup_income: "Income",
    landing_mockup_expense: "Expenses",
    landing_mockup_row1: "Salary · Payroll",
    landing_mockup_row2: "Housing · Rent",
    landing_mockup_row3: "Transport · Gas",
    landing_benefits_title_1: "Everything you need to",
    landing_benefits_title_2: "control your finances",
    landing_benefit_1_title: "Log in seconds",
    landing_benefit_1_desc: "Add income and expenses easily with customizable categories. No hassle.",
    landing_benefit_2_title: "Visualize your situation",
    landing_benefit_2_desc: "Clear charts of income vs expenses, balance over time, and spending by category.",
    landing_benefit_3_title: "Budgets by category",
    landing_benefit_3_desc: "Set a monthly limit per category and get alerts as you approach it. Control your spending effortlessly.",
    landing_benefit_4_title: "Manage pending items",
    landing_benefit_4_desc: "Track pending payments and collections so you never miss an important date.",
    landing_benefit_5_title: "Recurring payments",
    landing_benefit_5_desc: "Set up your fixed monthly expenses once and forget about logging them every month.",
    landing_benefit_6_title: "Multiple accounts",
    landing_benefit_6_desc: "Organize your money across bank accounts, cash, or digital wallets.",
    landing_benefit_7_title: "Multiple currencies",
    landing_benefit_7_desc: "Work in euros, Latin American currencies, pounds, and many others, whatever you need.",
    landing_benefit_8_title: "Export your data",
    landing_benefit_8_desc: "Download your history as CSV to analyze it or keep a copy whenever you want.",
    landing_pricing_title: "Simple, transparent pricing",
    landing_pricing_sub: "No surprises. Cancel anytime.",
    landing_plan_free: "FREE",
    landing_plan_free_period: "Forever",
    landing_plan_free_f1: "30 entries per month",
    landing_plan_free_f2: "3 months of history",
    landing_plan_free_f3: "Basic charts",
    landing_plan_free_f4: "All categories",
    landing_plan_free_cta: "Start for free",
    landing_plan_pro: "PRO",
    landing_plan_popular: "MOST POPULAR",
    landing_billing_monthly: "Monthly",
    landing_billing_annual: "Annual",
    landing_price_monthly_period: "/mo",
    landing_price_monthly_note: "Billed monthly",
    landing_price_annual_period: "/yr",
    landing_price_annual_note_1: "Equivalent to €1.67/mo ·",
    landing_price_annual_note_2: "Save €4",
    landing_plan_pro_f1: "Unlimited entries",
    landing_plan_pro_f2: "Full history",
    landing_plan_pro_f3: "Advanced charts",
    landing_plan_pro_f4: "Budgets by category",
    landing_plan_pro_f5: "Export to CSV",
    landing_plan_pro_f6: "Multiple currencies",
    landing_plan_pro_f7: "Priority support",
    landing_plan_pro_cta: "Subscribe now →",
    landing_final_title: "Start taking control of your money today",
    landing_final_sub: "Join the users who already know where their money goes every month.",
    landing_footer_privacy: "Privacy",
    landing_footer_terms: "Terms",
  }
};

export function t(lang, key) {
  return translations[lang]?.[key] ?? translations["es"][key] ?? key;
}